import { useAuth } from '../../providers/AuthProvider';

const PLAN_INFO = [
    {
        name: 'Talent Marketplace',
        details: [
            "• Get matched with top quality freelancers in real-time",
            "• 5000+ pre-vetted freelancers; individuals and teams",
            "• 50+ specialized roles and 1000s of skills",
            "• Intuitive, automated end-to-end hiring experience",
            "• Wripple Talent Guarantee",
        ],
    },
    {
        name: 'Freelance Operations',
        details: [
            "• Custom talent pools; add talent from your network",
            "• Track onboarding, contracts and financials",
            "• Manage talent usage, time tracking and payments",
            "• Automated classification and built-in compliance",
            "",
            "• EOR/AOR, indemnification and legal/risk guarantee",
        ],
    },
    {
        name: 'Seller Portal',
        details: [
            "• Create agency profile and listing in Agency Directory",
            "• Inbound leads from top brands",
            "• Utilize Wripple MSA for projects with new client wins",
        ],
        extra: {
            name: 'Seller Portal Pro',
            details: [
                "• Get matched with project briefs posted by brands",
                "• Access job board to propose on active opportunities",
                "• Quarterly promotions of your agency by Wripple",
            ],
        }
    },
    {
        name: 'Service Intelligence',
        details: [
            "• Suite of AI-based tools to enable agency modernization",
            "• Scoping, estimation and project plan generation",
            "• Market and pricing Intelligence",
            "• Agency and talent scoring, upskill recommendations",
        ],
    },
]


const PLANS = [
    {
        id: 1,
        name: "PAY-AS-YOU-GO \n \n",
        price: "$0 monthly",
        description: "Pay no monthly cost for agencies who utilize 1 or 2 freelance FTEs per month",
        features: {
            talentMarketplace: "Wripple Sourced - 14% Markup",
            freelanceOps: `Wripple Managed Ops
                • 21% Markup W2
                • 5% Markup 1099
            `,
            eor: "Included",
            sellerPortal: "Included",
            // sellerPortalPro: "+$49 Monthly (Free through Aug 2025)",
            sellerPortalPro: `+$49 Monthly
                (Free through December 2025)
            `,
            serviceIntelligence: "Available March 2026"
        }
    },
    {
        id: 2,
        name: "VIRTUAL BENCH \n+ SELLER PRO",
        price: "$199 monthly",
        description: "Lowest total cost for agencies who utilize 3-5 freelance FTEs per month",
        features: {
            talentMarketplace: "Wripple Sourced - 12% Markup",
            freelanceOps: `Wripple Managed Ops
                • 20% Markup W2
                • 4.5% Markup 1099
            `,
            eor: "Included",
            sellerPortal: "Included",
            sellerPortalPro: "Included",
            serviceIntelligence: "Free Beta Access (Sep 2025 - March 2026)"
        }
    },
    {
        id: 3,
        name: "VIRTUAL BENCH PRO \n+ SELLER PRO",
        price: "$399 monthly",
        description: "Lowest total cost for agencies who utilize 5 or more freelance FTEs per month",
        features: {
            talentMarketplace: "Wripple Sourced - 10% Markup",
            freelanceOps: `Wripple Managed Ops
                • 19% Markup W2
                • 4% Markup 1099
            `,
            eor: "Included",
            sellerPortal: "Included",
            sellerPortalPro: "Included",
            serviceIntelligence: "Free Beta Access (Sep 2025 - March 2026)"
        }
    }
];



const activeBG = 'bg-[#f5f1fd]';

const SupplierPlans = () => {

    const { auth } = useAuth();
    // console.log(auth, 'AAUUTTHH')
    // console.log(auth.user(), 'userrrrr')
    // console.log(auth.clientOrg(), 'client org')
    // console.log(auth.supplierOrg(), 'supplierOrg')

    const planId = auth.clientOrg().subscription.plan;

    // console.log(TB.invert(laravel.subscription_plans), 'inverted')
    // console.log(laravel.subscription_plans, 'not inverted')

    // const { subscription } = auth.auth.clien

    return (
        <div className="bg-white mt-[60px]">

            <div className="max-w-5xl w-full mx-auto p-4 md:p-6">
                {/* Header */}
                <div className="mb-6 md:mb-8">
                    <p className="text-sm md:text-base text-center text-gray-600">The all-in-one software platform for the modern agency.</p>
                </div>

                {/* Mobile Layout */}
                <div className="mdhidden space-y6">
                    <div className="bg-wripplePrimaryBrightPurple py-4 px-6 rounded-lg">
                        <h2 className="text-lg text-white font-semibold text-center">Agency Subscription Plans</h2>
                    </div>

                    <div className="flex flex-col md:flex-row gap-4md: gap-8 pt-8">
                        {PLANS.map((plan, index) => (
                            <div key={index} className={`border border-gray-300 rounded-lg overflow-hidden flex-1 ${planId === plan.id ? activeBG : ''}`}>
                                {/* Plan Header */}
                                {planId === plan.id ? (
                                    <div className="bg-wripplePrimaryBrightPurple font-semibold p-4 text-white text-center">
                                        Your Plan
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={() => console.log('upgrade clicked')}
                                        className="bg-wripplePrimaryBrightPurple p-4 font-semibold text-white w-full"
                                    >
                                        Upgrade Plan
                                    </button>
                                )}

                                <div className={`flex flex-col gap-1.5 justify-between items-center py-6 px-4 text-center border-b border-gray-300 min-h-52`}>
                                    <h3 className="text-lg min-h-14 font-semibold text-wripplePrimaryBrightPurple line-clamp-2 whitespace-pre-line">{plan.name}</h3>
                                    <p className="text-2xl font-bold text-gray-800">{plan.price}</p>
                                    {plan.description && (
                                        <p className="text-xs text-gray-500">{plan.description}</p>
                                    )}
                                </div>

                                {/* Features */}
                                <div className="divide-y divide-gray-200">
                                    <div className="p-4">
                                        <h4 className="text-lg font-medium text-wripplePrimaryBrightPurple mb-2">Talent Marketplace</h4>
                                        <p className="text-sm text-gray-700 whitespace-pre-line">{plan.features.talentMarketplace}</p>
                                    </div>
                                    <div className="p-4">
                                        <h4 className="text-lg font-medium text-wripplePrimaryBrightPurple mb-2">Freelance Operations</h4>
                                        <p className="text-sm text-gray-700 whitespace-pre-line">{plan.features.freelanceOps}</p>
                                    </div>
                                    <div className="p-4">
                                        <h4 className="text-lg font-medium text-wripplePrimaryBrightPurple mb-2">EOR/AOR</h4>
                                        <p className="text-sm text-gray-700 whitespace-pre-line">{plan.features.eor}</p>
                                    </div>
                                    <div className="p-4">
                                        <h4 className="text-lg font-medium text-wripplePrimaryBrightPurple mb-2">Seller Portal</h4>
                                        <p className="text-sm text-gray-700 whitespace-pre-line">{plan.features.sellerPortal}</p>
                                    </div>
                                    <div className="p-4 min-h-28">
                                        <h4 className="text-lg font-medium text-wripplePrimaryBrightPurple mb-2">Seller Portal Pro</h4>
                                        <p className="text-sm text-gray-700 whitespace-pre-line">{plan.features.sellerPortalPro}</p>
                                    </div>
                                    <div className="p-4 min-h-28">
                                        <h4 className="text-lg font-medium text-wripplePrimaryBrightPurple mb-2">Service Intelligence</h4>
                                        <p className="text-sm text-gray-700 whitespace-pre-line">{plan.features.serviceIntelligence}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="py-6">
                        <p className="text-center pb-4 text-2xl">Plan Details</p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8 flexwrap">
                            {PLAN_INFO.map(info => {
                                return (
                                    <div key={info.name} className="w1/2">
                                        <p className="text-xl text-wripplePrimaryBrightPurple font-medium pb-1.5">{info.name}</p>
                                        <ul>
                                            {info.details?.map(detail => {
                                                return (
                                                    <li key={detail}>{detail}</li>
                                                )
                                            })}
                                        </ul>

                                        {info.extra?.name && (
                                            <p className="text-base font-medium pb-1.5">{info.extra.name}</p>
                                        )}
                                        {info.extra?.details && (
                                            <ul>
                                                {info.extra.details.map(detail => {
                                                    return (
                                                        <li key={detail}>{detail}</li>
                                                    )
                                                })}
                                            </ul>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>


                    <div className="bg-black text-white py-4 px-6 text-center rounded-lg">
                        <p className="font-semibold text-sm text-white">Unlimited Users. No Fees to Freelancers.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SupplierPlans;
